var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "form-wrapper",
        {
          attrs: {
            redirection: "third.overview.informations",
            store: _vm.store,
            current: _vm.current,
            linkedForm: _vm.linkedForm,
            labelSaveAndAction: _vm.$t.__(
              "pages.forms.ThirdIndividualsForm.save_and_create_individual"
            )
          },
          on: { "catch-errors": _vm.catchErrors }
        },
        [
          _c("template", { slot: "title" }, [
            _vm._v(_vm._s(this.$l10n.__("Ajouter un nouveau particulier")))
          ]),
          _vm._v(" "),
          _c(
            "form-fields-wrapper",
            {
              attrs: {
                field: "individual",
                toggleAllowed: false,
                title: _vm.$t.__("pages.forms.ThirdIndividualsForm.individual")
              }
            },
            [
              _c("form-fields-individuals-details", {
                ref: "main",
                attrs: { "store-module": _vm.current, error: _vm.error.errors },
                on: { "change-type": _vm.changeType }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "form-fields-wrapper",
            {
              attrs: {
                field: "address",
                toggleAllowed: true,
                activeFields: ["address"],
                title: _vm.$t.__("pages.forms.ThirdIndividualsForm.address")
              }
            },
            [
              _vm._l(_vm.addresses, function(address, index) {
                return _c("form-fields-address", {
                  key: index,
                  attrs: {
                    index: _vm.formatIndex(index),
                    currentStore: _vm.current
                  }
                })
              }),
              _vm._v(" "),
              _vm.addressesFieldsStatus === "saved"
                ? _c("CompassButton", {
                    staticClass: "wp-10",
                    attrs: {
                      label: _vm.$t.__("common.actions.add_address"),
                      type: "secondary"
                    },
                    on: {
                      click: function($event) {
                        return _vm.createNewAddress()
                      }
                    }
                  })
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _vm.clientOrSupplier
            ? _c(
                "form-fields-wrapper",
                {
                  attrs: {
                    field: "accounting",
                    "active-fields": ["accounting"],
                    toggleAllowed: true,
                    title: _vm.$t.__("common.labels.accounting")
                  }
                },
                [
                  _c("form-fields-individuals-accountability", {
                    attrs: {
                      "store-module": _vm.current,
                      error: _vm.error.errors
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "form-fields-wrapper",
            {
              attrs: {
                field: "custom-fields",
                toggleAllowed: false,
                "active-fields": ["custom-fields"],
                title: _vm.$t.__(
                  "pages.forms.ThirdIndividualsForm.individual_custom_fields"
                )
              }
            },
            [
              _c("form-fields-custom-fields", {
                ref: "custom-fields",
                attrs: { currentStore: _vm.current, error: _vm.error.errors }
              })
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }